import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "../../src/js/api/queryClient";
import {ColourPaletteGenerator} from "~/react/components/colour-palette/colour-palette-generator";

function ColourPaletteRenderer() {
  const elements = document.querySelectorAll(".react-colour-palette");
  if (!elements) return;
  elements.forEach((element) => {
    createRoot(element).render(
      <StrictMode>
        <QueryClientProvider client={queryClient}>
            <ColourPaletteGenerator />
        </QueryClientProvider>
      </StrictMode>
    );
  });
}

export const initColourPalette = () => {
  if (document.readyState !== "loading") {
    ColourPaletteRenderer();
  } else {
    document.addEventListener("DOMContentLoaded", ColourPaletteRenderer);
  }
};
